import { render, staticRenderFns } from "./EditarTipoLiquidacion.vue?vue&type=template&id=4fcd45ef&"
import script from "./EditarTipoLiquidacion.vue?vue&type=script&lang=js&"
export * from "./EditarTipoLiquidacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports